function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#323232",
  d: "M12 8.364C9.99 8.364 8.364 9.99 8.364 12c0 2.01 1.627 3.636 3.636 3.636 2.01 0 3.636-1.627 3.636-3.636 0-2.01-1.627-3.636-3.636-3.636zm8.127 2.727C19.71 7.3 16.7 4.29 12.91 3.873v-.964C12.91 2.41 12.5 2 12 2s-.91.41-.91.91v.963C7.3 4.29 4.29 7.3 3.874 11.09h-.964C2.41 11.09 2 11.5 2 12s.41.91.91.91h.963c.418 3.79 3.427 6.8 7.218 7.217v.964c0 .5.409.909.909.909s.91-.41.91-.91v-.963c3.79-.418 6.8-3.427 7.217-7.218h.964c.5 0 .909-.409.909-.909s-.41-.91-.91-.91h-.963zM12 18.364c-3.518 0-6.364-2.846-6.364-6.364S8.482 5.636 12 5.636 18.364 8.482 18.364 12 15.518 18.364 12 18.364z"
});

var SvgIconCurrent = function SvgIconCurrent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCurrent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-current.dd567cb1.svg";
export { ForwardRef as ReactComponent };